import React, {useEffect, useState} from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import {Link, useNavigate} from 'react-router-dom';
import {Container, Row, Col, Button, Table, Pagination, Form, Modal} from 'react-bootstrap';
import {FaArrowLeft} from "react-icons/fa";
import {CloseLarge, RequestQuote, Search, TrashCan, View, ViewOff} from '@carbon/icons-react';
import {FiCopy} from "react-icons/fi";

export default function Users() {
    const keyLocalStorage = 'authToken';
    const navigate = useNavigate();

    const [users, setUsers] = useState([]);
    const [shopBranchs, setShopBranchs] = useState([]);

    const [showModalAddUser, setShowModalAddUser] = useState(false);
    const [showModalEditUser, setShowModalEditUser] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [currentNumberOfElements, setCurrentNumberOfElements] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    // Estados de Filtros
    const [nameFilter, setNameFilter] = useState("");
    const [lastNameFilter, setLastNameFilter] = useState("");
    const [usernameFilter, setUsernameFilter] = useState("");
    const [shopBranchFilter, setShopBranchFilter] = useState("");

    const [isLoading, setIsLoading] = useState(true);

    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [dni, setDni] = useState('');
    const [address, setAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [province, setProvince] = useState('');
    const [location, setLocation] = useState('');
    const [shopBranchId, setShopBranchId] = useState('');
    const [role, setRole] = useState('');

    const [idUserEdit, setIdUserEdit] = useState('');
    const [nameEdit, setNameEdit] = useState('');
    const [lastnameEdit, setLastnameEdit] = useState('');
    const [usernameEdit, setUsernameEdit] = useState('');
    const [dniEdit, setDniEdit] = useState('');
    const [addressEdit, setAddressEdit] = useState('');
    const [phoneNumberEdit, setPhoneNumberEdit] = useState('');
    const [provinceEdit, setProvinceEdit] = useState('');
    const [locationEdit, setLocationEdit] = useState('');
    const [shopBranchIdEdit, setShopBranchIdEdit] = useState('');
    const [roleEdit, setRoleEdit] = useState('');

    const roles = [
        { value: 'ADMIN', label: 'Administrador' },
        { value: 'USER', label: 'Usuario' },
        // Agregá los roles que necesites
    ];


    useEffect(() => {
        document.title = 'QReate - Usuarios';
        getPage();
        getShopBranchs();
    }, [currentPage, isLoading]);

    // Armado de la página
    const getPage = () => {
        axios.get(process.env.REACT_APP_API_USER_PAGE_ROUTE, {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            },
            params: {
                page: currentPage,
                username: usernameFilter,
                name: nameFilter,
                lastName: lastNameFilter,
                shopBranch: shopBranchFilter
            }
        })
            .then(response => {
                setUsers(response.data.content);
                setTotalPages(response.data.totalPages);
                setCurrentPage(response.data.number + 1);
                setCurrentNumberOfElements(response.data.numberOfElements)
                setTotalElements(response.data.totalElements)
            })
            .catch(error => {
                console.warn(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getShopBranchs = () => {
        axios.get(process.env.REACT_APP_API_SHOP_BRANCH_LIST_ROUTE, {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            }
        })
            .then(response => {
                console.log(response.data);
                setShopBranchs(response.data);
            })
            .catch(error => {
                console.warn(error);
            });
    }

    // Manejo de filtros
    const filtersContainer = () => {
        return (
            <Container>
                <Row className="mt-3 justify-content-center" xs={2} md={3}>
                    {/* Filtro por Nombre: Guarda el nombre del producto */}
                    <Col>
                        <Form.Group controlId="nameFilter">
                            <Form.Control
                                className="filtersStyle"
                                type="text"
                                placeholder="Buscar por nombre"
                                value={nameFilter}
                                onChange={(e) => setNameFilter(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group controlId="nameFilter">
                            <Form.Control
                                className="filtersStyle"
                                type="text"
                                placeholder="Buscar por apellido"
                                value={lastNameFilter}
                                onChange={(e) => setLastNameFilter(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    {/* Filtro por Descripción: Guarda la descripción del producto */}
                    <Col>
                        <Form.Group controlId="descriptionFilter">
                            <Form.Control
                                className="filtersStyle"
                                type="text"
                                placeholder="Buscar por nombre de usuario"
                                value={usernameFilter}
                                onChange={(e) => setUsernameFilter(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group controlId="descriptionFilter">
                            <Form.Select
                                className="filtersStyle"
                                value={shopBranchFilter}
                                onChange={(e) => setShopBranchFilter(e.target.value)}
                            >
                                <option value="">Seleccionar sucursal</option>
                                {shopBranchs.map((branch) => (
                                    <option key={branch.id} value={branch.id}>
                                        {branch.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>


                    {/* Botones de Búsqueda y Limpiar */}
                    <Col className="text-center text-md-start mt-3 mt-md-0 mb-sm-3 mb-md-0">
                        <Button id="btnSearchProduct" className="me-1" variant="primary" onClick={() => getPage()}>
                            <Search/>
                        </Button>
                        <Button id="btnCleanSearchProducts" className="ms-1" variant="primary" onClick={() => cleanFilters()}>
                            <CloseLarge/>
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    };

    const modalControlButtons = () => {
        return (
            <Container className="mt-3">
                <Row>
                    <Col className="text-alig-center">
                        <Button variant="primary" className="me-1"
                                onClick={() => setShowModalAddUser(true)}>Agregar</Button>
                    </Col>
                </Row>
            </Container>
        )
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const cleanFilters = () => {
        setUsernameFilter("");
        setShopBranchFilter("");
        setLastNameFilter("");
        setNameFilter("");
        setIsLoading(true);
        getPage();
    }

    // Estados para el manejo de errores
    const [errors, setErrors] = useState({
        username: false,
        password: false,
    });

    const [errorsEdit, setErrorsEdit] = useState({
        usernameEdit: false,
        passwordEdit: false,
    });

    const handleSaveUser = () => {
        if (validateFields()) {
            saveUser(); // Llamar a la función para guardar si no hay errores
        }
    };

    const handleUpdateUser = () => {
        if (validateFieldsEdit()) {
            editUser(); // Llamar a la función para guardar si no hay errores
        }
    };

    const validateFields = () => {
        const newErrors = {
            name: name === '',
            lastname: lastname === '',
            username: username === '',
            password: password === '',
            dni: dni === '',
            address: address === '',
            phoneNumber: phoneNumber === '',
            province: province === '',
            location: location === '',
            shopBranchId: shopBranchId === '',
            role: role === '',
        };

        setErrors(newErrors);

        // Retornar true si no hay errores
        return !Object.values(newErrors).includes(true);
    };


    const validateFieldsEdit = () => {
        const newErrorsEdit = {
            nameEdit: nameEdit === '',
            lastnameEdit: lastnameEdit === '',
            usernameEdit: usernameEdit === '',
            dniEdit: dniEdit === '',
            addressEdit: addressEdit === '',
            phoneNumberEdit: phoneNumberEdit === '',
            provinceEdit: provinceEdit === '',
            locationEdit: locationEdit === '',
            shopBranchIdEdit: shopBranchIdEdit === '',
            roleEdit: roleEdit === '',
        };

        setErrorsEdit(newErrorsEdit);

        // Retornar true si no hay errores
        return !Object.values(newErrorsEdit).includes(true);
    };


    const addUserModal = () => {
        return (
            <Modal className="modal fade modal-lg" show={showModalAddUser} onHide={() => setShowModalAddUser(false)}>
                <Modal.Header className="modal-header">
                    <h1 className="modal-title fs-5 titleModalCreateProduct" id="modaleAddProductLabel">
                        Nuevo usuario
                    </h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            onClick={() => resetCreateForm()}></button>
                </Modal.Header>
                <Modal.Body className="modal-body">

                    {/* Nombre */}
                    <div className="mb-3">
                        <label className="col-form-label">Nombre:</label>
                        <input type="text" className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                               value={name} onChange={(e) => setName(e.target.value)} />
                        {errors.name && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Apellido */}
                    <div className="mb-3">
                        <label className="col-form-label">Apellido:</label>
                        <input type="text" className={`form-control ${errors.lastname ? 'is-invalid' : ''}`}
                               value={lastname} onChange={(e) => setLastname(e.target.value)} />
                        {errors.lastname && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Usuario */}
                    <div className="mb-3">
                        <label className="col-form-label">Nombre de usuario:</label>
                        <input type="text" className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                               value={username} onChange={(e) => setUsername(e.target.value)} />
                        {errors.username && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Contraseña */}
                    <div className="mb-3">
                        <label className="col-form-label">Contraseña:</label>
                        <input type="password" className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                               value={password} onChange={(e) => setPassword(e.target.value)} />
                        {errors.password && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* DNI */}
                    <div className="mb-3">
                        <label className="col-form-label">DNI:</label>
                        <input type="text" className={`form-control ${errors.dni ? 'is-invalid' : ''}`}
                               value={dni} onChange={(e) => setDni(e.target.value)} />
                        {errors.dni && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Dirección */}
                    <div className="mb-3">
                        <label className="col-form-label">Dirección:</label>
                        <input type="text" className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                               value={address} onChange={(e) => setAddress(e.target.value)} />
                        {errors.address && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Teléfono */}
                    <div className="mb-3">
                        <label className="col-form-label">Teléfono:</label>
                        <input type="text" className={`form-control ${errors.phoneNumber ? 'is-invalid' : ''}`}
                               value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                        {errors.phoneNumber && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Provincia */}
                    <div className="mb-3">
                        <label className="col-form-label">Provincia:</label>
                        <input type="text" className={`form-control ${errors.province ? 'is-invalid' : ''}`}
                               value={province} onChange={(e) => setProvince(e.target.value)} />
                        {errors.province && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Localidad */}
                    <div className="mb-3">
                        <label className="col-form-label">Localidad:</label>
                        <input type="text" className={`form-control ${errors.location ? 'is-invalid' : ''}`}
                               value={location} onChange={(e) => setLocation(e.target.value)} />
                        {errors.location && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Sucursal (selector) */}
                    <div className="mb-3">
                        <label className="col-form-label">Sucursal:</label>
                        <select className={`form-select ${errors.shopBranchId ? 'is-invalid' : ''}`}
                                value={shopBranchId} onChange={(e) => setShopBranchId(e.target.value)}>
                            <option value="">Seleccionar una sucursal</option>
                            {shopBranchs.map(branch => (
                                <option key={branch.id} value={branch.id}>
                                    {branch.name}
                                </option>
                            ))}
                        </select>
                        {errors.shopBranchId && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Rol */}
                    <div className="mb-3">
                        <label htmlFor="role" className="col-form-label">Rol:</label>
                        <select
                            className={`form-control ${errors.role ? 'is-invalid' : ''}`}
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="">Seleccione un rol</option>
                            {roles.map((r) => (
                                <option key={r.value} value={r.value}>
                                    {r.label}
                                </option>
                            ))}
                        </select>
                        {errors.role && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>


                </Modal.Body>
                <Modal.Footer className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => resetCreateForm()}>
                        Cerrar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={handleSaveUser}>
                        Guardar
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    const resetCreateForm = () => {
        setName('');
        setLastname('');
        setUsername('');
        setPassword('');
        setDni('');
        setAddress('');
        setPhoneNumber('');
        setProvince('');
        setLocation('');
        setShopBranchId('');
        setRole('');

        setErrors({
            name: null,
            lastname: null,
            username: null,
            password: null,
            dni: null,
            address: null,
            phoneNumber: null,
            province: null,
            location: null,
            shopBranchId: null,
            role: null,
        });
        setShowModalAddUser(false);
    };

    const resetEditForm = () => {
        setIdUserEdit('');
        setNameEdit('');
        setLastnameEdit('');
        setUsernameEdit('');
        setDniEdit('');
        setAddressEdit('');
        setPhoneNumberEdit('');
        setProvinceEdit('');
        setLocationEdit('');
        setShopBranchIdEdit('');
        setRoleEdit('');

        setErrorsEdit({
            nameEdit: null,
            lastnameEdit: null,
            usernameEdit: null,
            passwordEdit: null,
            dniEdit: null,
            addressEdit: null,
            phoneNumberEdit: null,
            provinceEdit: null,
            locationEdit: null,
            shopBranchIdEdit: null,
            roleEdit: null,
        });
        setShowModalEditUser(false);
    };



    const editUserModal = () => {
        return(
            <Modal className="modal fade modal-lg" show={showModalEditUser} onHide={() => setShowModalEditUser(false)}>
                <Modal.Header className="modal-header">
                    <h1 className="modal-title fs-5 titleModalCreateProduct" id="modalEditUserLabel">
                        Editar usuario
                    </h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            onClick={() => resetEditForm()}></button>
                </Modal.Header>
                <Modal.Body className="modal-body">

                    {/* Nombre */}
                    <div className="mb-3">
                        <label className="col-form-label">Nombre:</label>
                        <input type="text" className={`form-control ${errorsEdit.nameEdit ? 'is-invalid' : ''}`}
                               value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} />
                        {errorsEdit.nameEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Apellido */}
                    <div className="mb-3">
                        <label className="col-form-label">Apellido:</label>
                        <input type="text" className={`form-control ${errorsEdit.lastnameEdit ? 'is-invalid' : ''}`}
                               value={lastnameEdit} onChange={(e) => setLastnameEdit(e.target.value)} />
                        {errorsEdit.lastnameEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Usuario */}
                    <div className="mb-3">
                        <label className="col-form-label">Nombre de usuario:</label>
                        <input type="text" className={`form-control ${errorsEdit.usernameEdit ? 'is-invalid' : ''}`}
                               value={usernameEdit} onChange={(e) => setUsernameEdit(e.target.value)} />
                        {errorsEdit.usernameEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* DNI */}
                    <div className="mb-3">
                        <label className="col-form-label">DNI:</label>
                        <input type="text" className={`form-control ${errorsEdit.dniEdit ? 'is-invalid' : ''}`}
                               value={dniEdit} onChange={(e) => setDniEdit(e.target.value)} />
                        {errorsEdit.dniEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Dirección */}
                    <div className="mb-3">
                        <label className="col-form-label">Dirección:</label>
                        <input type="text" className={`form-control ${errorsEdit.addressEdit ? 'is-invalid' : ''}`}
                               value={addressEdit} onChange={(e) => setAddressEdit(e.target.value)} />
                        {errorsEdit.addressEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Teléfono */}
                    <div className="mb-3">
                        <label className="col-form-label">Teléfono:</label>
                        <input type="text" className={`form-control ${errorsEdit.phoneNumberEdit ? 'is-invalid' : ''}`}
                               value={phoneNumberEdit} onChange={(e) => setPhoneNumberEdit(e.target.value)} />
                        {errorsEdit.phoneNumberEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Provincia */}
                    <div className="mb-3">
                        <label className="col-form-label">Provincia:</label>
                        <input type="text" className={`form-control ${errorsEdit.provinceEdit ? 'is-invalid' : ''}`}
                               value={provinceEdit} onChange={(e) => setProvinceEdit(e.target.value)} />
                        {errorsEdit.provinceEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Localidad */}
                    <div className="mb-3">
                        <label className="col-form-label">Localidad:</label>
                        <input type="text" className={`form-control ${errorsEdit.locationEdit ? 'is-invalid' : ''}`}
                               value={locationEdit} onChange={(e) => setLocationEdit(e.target.value)} />
                        {errorsEdit.locationEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Sucursal (selector) */}
                    <div className="mb-3">
                        <label className="col-form-label">Sucursal:</label>
                        <select className={`form-select ${errorsEdit.shopBranchIdEdit ? 'is-invalid' : ''}`}
                                value={shopBranchIdEdit} onChange={(e) => setShopBranchIdEdit(e.target.value)}>
                            <option value={-1}>Seleccionar una sucursal</option>
                            {shopBranchs.map(branch => (
                                <option key={branch.id} value={branch.id}>
                                    {branch.name}
                                </option>
                            ))}
                        </select>
                        {errorsEdit.shopBranchIdEdit && <div className="invalid-feedback">Campo obligatorio</div>}
                    </div>

                    {/* Rol */}
                    <div className="mb-3">
                        <label htmlFor="role" className="col-form-label">Rol:</label>
                        <select
                            className={`form-control ${errorsEdit.roleEdit ? 'is-invalid' : ''}`}
                            value={roleEdit}
                            onChange={(e) => setRoleEdit(e.target.value)}
                        >
                            <option value="">Seleccione un rol</option>
                            {roles.map((r) => (
                                <option key={r.value} value={r.value}>
                                    {r.label}
                                </option>
                            ))}
                        </select>
                        {errorsEdit.roleEdit && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>

                </Modal.Body>
                <Modal.Footer className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => resetEditForm()}>
                        Cerrar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={handleUpdateUser}>
                        Guardar cambios
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    const saveUser = () => {
        const userDTO = {
            name: name.trim(),
            lastName: lastname.trim(),
            username: username.trim(),
            password: password.trim(),
            dni: dni.trim(),
            address: address.trim(),
            phone: phoneNumber.trim(),
            state: province.trim(),
            location: location.trim(),
            shopBranchId: shopBranchId,
            role: role
        };
        axios.post(process.env.REACT_APP_API_USER_ADD_ROUTE, userDTO, {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            }
        })
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Creado correctamente.',
                    timer: 1500,
                    showConfirmButton: false,
                });
                resetCreateForm()
                getPage();
            })
            .catch(error => {
                const errorMessage = error.response?.data.message || 'Ocurrió un error inesperado';
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage,
                    confirmButtonText: 'Cerrar',
                });
            });
    }

    const editUser = () => {
        const userDTO = {
            id: idUserEdit,
            name: nameEdit.trim(),
            lastName: lastnameEdit.trim(),
            username: usernameEdit.trim(),
            dni: dniEdit.trim(),
            address: addressEdit.trim(),
            phone: phoneNumberEdit.trim(),
            state: provinceEdit.trim(),
            location: locationEdit.trim(),
            shopBranchId: shopBranchIdEdit,
            role: roleEdit
        };
        axios.put(process.env.REACT_APP_API_USER_EDIT_ROUTE, userDTO, {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            }
        })
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Creado correctamente.',
                    timer: 1500,
                    showConfirmButton: false,
                });
                resetEditForm()
                getPage();
            })
            .catch(error => {
                const errorMessage = error.response?.data.message || 'Ocurrió un error inesperado';
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage,
                    confirmButtonText: 'Cerrar',
                });
            });
    }

    const editUserField = (user) => {
        setIdUserEdit(user.id || '');
        setNameEdit(user.name || '');
        setNameEdit(user.name || '');
        setLastnameEdit(user.lastName || '');
        setUsernameEdit(user.username || '');
        setDniEdit(user.dni || '');
        setAddressEdit(user.address || '');
        setPhoneNumberEdit(user.phone || '');
        setProvinceEdit(user.state || '');
        setLocationEdit(user.location || '');
        setShopBranchIdEdit(user.shopBranchId || '');
        setRoleEdit(user.role || '');

        // También podrías limpiar errores de edición si querés:
        setErrorsEdit({
            nameEdit: false,
            lastnameEdit: false,
            usernameEdit: false,
            passwordEdit: false,
            dniEdit: false,
            addressEdit: false,
            phoneNumberEdit: false,
            provinceEdit: false,
            locationEdit: false,
            shopBranchIdEdit: false,
            roleEdit: false,
        });
    };


    const paginationModule = () => {
        return (
            <Container fluid>
                <Row>
                    <Col className="d-flex align-items-center">
                        <Pagination>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1}/>
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)}
                                             disabled={currentPage === 1}/>
                            {currentPage > 2 && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage - 2)}>
                                    {currentPage - 2}
                                </Pagination.Item>
                            )}
                            {currentPage > 1 && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage - 1)}>
                                    {currentPage - 1}
                                </Pagination.Item>
                            )}
                            <Pagination.Item active>{currentPage}</Pagination.Item>
                            {currentPage < totalPages && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>
                                    {currentPage + 1}
                                </Pagination.Item>
                            )}
                            {currentPage < totalPages - 1 && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage + 2)}>
                                    {currentPage + 2}
                                </Pagination.Item>
                            )}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)}
                                             disabled={currentPage === totalPages || shopBranchs.length === 0}/>
                            <Pagination.Last onClick={() => handlePageChange(totalPages)}
                                             disabled={currentPage === totalPages || shopBranchs.length === 0}/>
                        </Pagination>
                        <div className="ms-2">
                            <p>Mostrando {currentNumberOfElements} de {totalElements} </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }

    const loadingTable = () => {
        return (
            <>
                <div className="m-3">
                    <Table responsive className="table-striped">
                        <thead className="tableHead">
                        <tr>
                            <th>Nombre completo</th>
                            <th>Nombre de usuario</th>
                            <th>Rol</th>
                            <th>Sucursal</th>
                            <th>DNI</th>
                            <th>Provincia</th>
                            <th>Ciudad</th>
                            <th>Domicilio</th>
                            <th>Numero de telefono</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colSpan="3" className="backgroundTable text-center">
                                <div className="loader-container-listado">
                                    <div className="loader"></div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </>
        )
    }

    return (
        <div className="containersStock">

            <>
                <Container className="mt-3">
                    <Row>
                        <Col>
                            <h1 className="titleStock">Usuarios</h1>
                        </Col>
                    </Row>
                </Container>

                <div className="productsContainer">

                    <>
                        {filtersContainer()}

                        {(isLoading) ? (
                            loadingTable()
                        ) : (
                            <div className="m-3">
                                <Table responsive className="table-striped">
                                    <thead className="tableHead">
                                    <tr>
                                        <th>Nombre completo</th>
                                        <th>Nombre de usuario</th>
                                        <th>Rol</th>
                                        <th>Sucursal</th>
                                        <th>DNI</th>
                                        <th>Provincia</th>
                                        <th>Ciudad</th>
                                        <th>Domicilio</th>
                                        <th>Numero de telefono</th>
                                        <th style={{width: '5%'}}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        users.map(user => (
                                            <tr key={user.id}>
                                                <td className="text-alig-center">{user.name} {user.lastName}</td>
                                                <td className="text-alig-center">{user.username}</td>
                                                <td className="text-alig-center">
                                                    {roles.find(r => r.value === user.role)?.label || user.role}
                                                </td>
                                                <td className="text-alig-center">{user.shopBranchName}</td>
                                                <td className="text-alig-center">{user.dni}</td>
                                                <td className="text-alig-center">{user.state}</td>
                                                <td className="text-alig-center">{user.location}</td>
                                                <td className="text-alig-center">{user.address}</td>
                                                <td className="text-alig-center">{user.phone}</td>
                                                <td className="text-alig-center">
                                                    <div style={{display: "flex"}}>
                                                    <button
                                                        className="btn btnCopy"
                                                        data-test-cy="btnCopyId"
                                                        title={`ID: ${user.id}`}
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(user.id.toString());
                                                            Swal.fire({
                                                                icon: 'success',
                                                                title: '¡Copiado!',
                                                                text: 'ID copiado al portapapeles',
                                                                timer: 1500,
                                                                showConfirmButton: false
                                                            });
                                                        }}
                                                    >
                                                        <FiCopy size="20"/>
                                                    </button>
                                                    <button className="btn btnEdit" data-test-cy="btnEditLocation"><RequestQuote
                                                        className="btnEdit" size="24"
                                                        onClick={() => {
                                                            editUserField(user);
                                                            setShowModalEditUser(true);
                                                        }}/></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>

                            </div>
                        )}
                        {paginationModule()}
                        {modalControlButtons()}
                        {addUserModal()}
                        {editUserModal()}
                    </>
                </div>
            </>
        </div>
    );
}